import React from "react";

export default function Tabs({ value, onChange, items }) {
	return (
		<div className="tabs">
			<div className="tabs-bar">
				{items.map((it) => (
					<button
						key={it.value}
						className={`tab ${value === it.value ? "active" : ""}`}
						onClick={() => onChange(it.value)}
						type="button"
					>
						{it.label}
					</button>
				))}
			</div>
		</div>
	);
}